import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        userLocation: null,
        selectedCountry: "Греция",
        distance: null,
        location: null,
        email: null
    },
    mutations: {
        SET_USER_LOCATION: (state,payload) => state.userLocation = payload,
        SET_SELECTED_COUNTRY: (state,payload) => state.selectedCountry = payload,
        SET_DISTANCE:(state,payload) => state.distance = payload,
        SET_USER_COUNTRY:(state,payload) => state.location = payload,
        SET_EMAIL:(state,payload) => state.email = payload
    },
    getters: {},
    actions: {
        async getDistance({state,commit},body) {
         const data = await axios.get(`https://lg-travel.24ttl.net/api/origin/${state.location}/distance/${body}`)
     if(data.data){
         commit('SET_DISTANCE',`${Math.trunc(data.data)} км.`)
     }else{
         commit('SET_DISTANCE','0 м')
     }
         },
        async getUserLocation({commit,state}){
            const data = await axios.get(`https://lg-travel.24ttl.net/api/location/${state.userLocation.lat},${state.userLocation.lng}`)
           commit('SET_USER_COUNTRY',data.data.results[5].formatted_address)
        },
        async sendForm({state},data){
            console.log(state)
            return  await axios.post('https://lg-travel.24ttl.net/api/user/create',data)
        },
        async updateCountryEmail({state},data){
            console.log(state)
            return await axios.post('https://lg-travel.24ttl.net/api/user/update-email',data)
        }
    }
})